import * as React from 'react';
import wrapStore from '@src/utils/wrap-store';
import CultureSwiperStore from './store';
import BaseSwiper from '@src/components/swiper/base-swiper';
import cx from 'classnames';

const styles = require('./index.less');

/**
 * CultureSwiper
 * @param store {CultureSwiperStore}
 * @returns {JSX.Element}
 * @constructor
 */
const CultureSwiper = ({ store }) => {
  store.use();
  const renderSwiper = () => {
    if (store.list.length === 0) {
      return null;
    }
    return (
      <BaseSwiper store={store.swiperStore}>
        {store.list.map((item, key) => {
          return (
            <div className={styles.listItem} key={key}>
              <img src={item.img} alt={''} />
            </div>
          );
        })}
      </BaseSwiper>
    );
  };

  const renderPagination = () => {
    if (store.list.length <= 1) {
      return null;
    }
    return (
      <div className={styles.paginationContainer}>
        <div className={styles.paginationBox}>
          {store.list.map((item, key) => {
            return <div className={cx(styles.paginationItem, store.swiperStore.activeIndex === key && styles.active)} key={key} />;
          })}
        </div>
        <div className={styles.paginationArrowBox}>
          <div className={styles.paginationArrowLeft} onClick={store.onClickSwiperGoPrev} />
          <div className={styles.paginationArrowRight} onClick={store.onClickSwiperGoNext} />
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (store.list.length === 0) {
      return null;
    }
    return store.list[store.swiperStore.activeIndex]?.title;
  };

  return (
    <div className={styles.root}>
      <div className={styles.swiperBox}>
        {renderSwiper()}
        {renderPagination()}
      </div>
      <div className={styles.content}>{renderContent()}</div>
    </div>
  );
};

export default wrapStore(CultureSwiper, CultureSwiperStore);
